export const TEMPLATES_LIMIT = 1000;
export const TEMPLATES_INITIAL_ITEMS_OFFSET = 0;
export const TEMPLATES_ORDER_BY = 'created_at DESC';
